import { UseQueryResult, useQuery } from "@tanstack/react-query";
import {
  IDashboardGraph,
  IDashboardParams,
  IResponseDashboardCentral,
} from "../../interface";
import { axiosCentral, throwResponse } from "config/axios";

export const useGetDashboardResident = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IDashboardGraph[]>[], Error> => {
  return useQuery(
    ["dashboard-resident", "count-increased-per-month", params],
    async () => {
      const res = await axiosCentral.get(
        "/dashboard/residents/count-increased-per-month",
        {
          params,
        }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
